import apiClient, { downloadFile } from "../../../../../services/apiClient";

export const childrenApi = {
  // Получение программ садика
  getKindergartenPrograms: async (kgId) => {
    const type = 'Парціальні програми';
    try {
      const response = await apiClient.get(`content/doc_info?id=${kgId}&type=${type}`);
      return response.data || [];
    } catch (error) {
      console.error('Error loading kindergarten programs:', error);
      return [];
    }
  },

  // Получение информации о посещениях
  getAttendsInfo: async (childId) => {
    try {
      const now = new Date();
      const firstDayOfMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01T00:00`;
      const response = await apiClient.get(`get_attends_parent?id_ch=${childId}&date_from=${firstDayOfMonth}`);
      return response.data || [];
    } catch (error) {
      console.error('Error loading attends info:', error);
      return [];
    }
  },

  // Получение информации о начислениях
  getBillingInfo: async (childId, kgId) => {
    try {
      const response = await apiClient.get(`get_ch_billing?id_ch=${childId}&kg_id=${kgId}`);
      return response.data || [];
    } catch (error) {
      console.error('Error loading billing info:', error);
      return [];
    }
  },

  // Получение информации об оплатах
  getPaymentsInfo: async (childId, kgId) => {
    try {
      const response = await apiClient.get(`get_ch_payments?id_ch=${childId}&kg_id=${kgId}`);
      return response.data || [];
    } catch (error) {
      console.error('Error loading payments info:', error);
      return [];
    }
  },

  // Скачивание счета
  downloadInvoice: async (childId, kgId) => {
    try {
      const url = `ch_invite?id_ch=${childId}&kg_id=${kgId}`;
      const fileName = `рахунок_${childId}.pdf`;
      await downloadFile(url, fileName);
      return true;
    } catch (error) {
      console.error('Error downloading invoice:', error);
      throw new Error('Помилка при отриманні рахунку');
    }
  },

  // Поиск улиц
  searchStreet: async (searchString) => {
    try {
      const response = await apiClient.get(`iks_address_street?search=${encodeURIComponent(searchString)}`);
      return response.data || [];
    } catch (error) {
      console.error('Error searching street:', error);
      return [];
    }
  },

  // Получение списка домов
  listHouses: async (streetId) => {
    try {
      const response = await apiClient.get(`iks_address_house?id_street=${streetId}`);
      return response.data || [];
    } catch (error) {
      console.error('Error loading houses:', error);
      return [];
    }
  },

  // Сохранение адреса
  saveAddress: async (addressInfo) => {
    try {
      const response = await apiClient.post('children/address_kyiv', addressInfo);
      return response.data;
    } catch (error) {
      console.error('Error saving address:', error);
      throw new Error('Помилка при збереженні адреси');
    }
  },

  // Получение списка детей пользователя
  getUserChildren: async () => {
    try {
      const response = await apiClient.get('get_user_info_children');
      return response.data || [];
    } catch (error) {
      console.error('Error loading user children:', error);
      return [];
    }
  },

  // Получение краткой информации о садиках
  getKindergartenShortInfo: async (kgIds) => {
    try {
      const queryString = kgIds.map(id => `_id=${id}`).join('&');
      const response = await apiClient.get(`kg_short?${queryString}`);
      return response.data || [];
    } catch (error) {
      console.error('Error loading kindergarten info:', error);
      return [];
    }
  }
};